import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from "styled-components";
import { useDispatch, useSelector } from 'react-redux';
import * as moment from 'moment';
import RightArrow from "web/assets/images/right-arrow-dark-blue.webp";
import CheckboxInput from 'web/components/form-elements/CheckboxInput';
import AlertModal from 'web/components/AlertModal';
import ConfirmationModal from "web/components/ConfirmationModal";
import { sellerDelReqOrderCheckoutAcceptApi } from 'redux/actions/checkout';
import { deliveryReqOrderDeclineApi } from "redux/actions/myPickupOrders"
import { PayWith, RequestPickUpAddressStyle, TendorDetailsWrapper, Footerstyle, Heading, AccountSection, AccountType, AccountDetail, Location, To, ReviewFooter, Des, CommentSection, } from '../checkOutStyle';
import { fetchLanguageContentNew } from 'redux/actions/language';
import { stateConvert } from 'web/components/utils/stateAbbreviation';

const ViewDetails = ({ checkoutPageData, props }) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const token = localStorage.getItem('token');

  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()

  const [alertType, setAlertType] = useState('')
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const toggleModal = () => setModal(!modal);

  const [confirmationComment, setConfirmationComment] = useState("");
  const [yesNoConfirmationmodal, setYesNoConfirmationModal] = useState(false);
  const [yesNoConfirmationModalContent, setYesNoConfirmationModalContent] = useState("");

  useEffect(() => {
    if (languageContentNew?.Pallets_Listing_Pages) setPageLanguageContents(languageContentNew.Pallets_Listing_Pages)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  const declineDelReqOrderFunc = () => {
    setAlertType('declineOrder')
    setYesNoConfirmationModalContent("Please provide a reason for declining this load request.");
    setYesNoConfirmationModal(true);
  }

  const declineDelReqOrderConfirmation = async () => {
    let response;
    setYesNoConfirmationModal(false)
    const token = localStorage.getItem('token');
    let data = {
      locationId: localStorage.getItem('locationId'),
      tenderId: checkoutPageData?.tenderId,
      comment: confirmationComment ?? null,
      tenderStatus: 'REJECTED'
    }
    response = await dispatch(deliveryReqOrderDeclineApi(data, token));
    if (response?.success) {
      setAlertType('sellerDelReqOrderCheckoutDecline');
      setModalContent(response?.data?.msg);
      setModal(true);
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModal(true);
      }
    }
  }

  const acceptFunction = async () => {
    let pageValues = props.values
    let response;
    let data = {
      tenderId: checkoutPageData?.tenderId,
      locationId: localStorage.getItem('locationID'),
      comments: pageValues?.note
    }
    response = await dispatch(sellerDelReqOrderCheckoutAcceptApi(data, token));
    if (response?.success) {
      setAlertType('sellerDelReqOrderCheckoutAccept')
      setModalContent(response?.data?.msg);
      setModalLink();
      toggleModal();
    } else {
      if (response?.statusCode === 401) {
        history.push('./sign-in')
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  }

  const formatEquipmentTypes = equips => {
    const equipMapping = { "FLAT_BED": "Flatbed", "ENCLOSED_TRAILER": "Enclosed Trailer", "STRAIGHT_TRUCK": "Straight Truck" };
    return equips.map(equips => equipMapping[equips]).join(', ');
  }

  const palletDetailsString = () => {
    let data = checkoutPageData?.palletDetails
    if (data) {
      let material = data?.material;
      let condition = data?.condition?.length !== 1 ? data?.condition?.join(", ") : data?.condition;
      let moisture = data?.moisture ? `, ${data?.moisture}` : "";
      let size = data?.size ? (data?.size === "Custom" ? `${data?.size}, ${data?.length}x${data?.width}x${data?.height}` : data?.size) : "";
      let grade = data?.grade ? `, ${data?.grade}` : "";
      let isHeatTreated = data?.heatTreared ? ", HT" : "";
      let palletType = data?.material === "WOOD" ? `, ${data?.palletType}` : "";
      let hardOrSoftWood = data?.newConditionType === "HARDWOOD" ? "(HW)" : (data?.newConditionType === "SOFTWOOD" ? "(SW)" : "");
      let LWH = data?.material !== "WOOD" ? `${data?.length}x${data?.width}x${data?.height}` : "";
      let truckPreference = checkoutPageData?.equipment

      if (data?.material !== "WOOD") {
        return condition ? `${material}, ${LWH} - ${condition}, ${truckPreference}` : `${material}, ${LWH}, ${truckPreference}`;
      } else {
        return `${size}${grade}${moisture}${isHeatTreated}${palletType} - ${condition || ""}${hardOrSoftWood}, ${truckPreference}`;
      }
    }
  }

  const checkBoxlabel = () => {
    return <p style={{ margin: 0 }}>By accepting this delivery, you agree to the terms and conditions outlined <span style={{ color: 'blue' }} onClick={() => {
      window.open(process.env.REACT_APP_WEB_URL + 'checkout-terms-and-conditions', "_blank")
    }}>here</span>. </p>
  }

  return (
    <>
      <div></div>
      <div className="checkout-cont">
        <Description>
          <div className="product-header-sec">
            <img
              src={RightArrow}
              alt="RightArrow"
              className="right-arrow"
            />
            <div class="community-name" style={{ fontWeight: 'bold' }}>Review Delivery Request</div>
          </div>
          <p>Please review the following delivery request details and accept the load. Upon acceptance, the delivery order will be created.</p>
        </Description>
        <PayWith>
          <Location>
            <Heading>Delivery Address:</Heading>
            <RequestPickUpAddressStyle>
              <div>
                <p style={{ fontWeight: 'bold' }}>{checkoutPageData?.deliveryAddress?.locationName}</p>
                <p>{checkoutPageData?.deliveryAddress?.street}</p>
                <p>{checkoutPageData?.deliveryAddress?.city}, {stateConvert(checkoutPageData?.deliveryAddress?.state) || checkoutPageData?.deliveryAddress?.state} {checkoutPageData?.deliveryAddress?.zipCode}</p>
              </div>
            </RequestPickUpAddressStyle>

            <TendorDetailsWrapper style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
              <div>
                <p>Order Quantity</p>
                <input disabled value={checkoutPageData?.quantity} />
              </div>
              <div>
                <p>Equipment</p>
                <input disabled value={checkoutPageData?.equipmentRequirements ? formatEquipmentTypes(checkoutPageData?.equipmentRequirements) : 'NA'} />
              </div>
              <div>
                <p>PO Number</p>
                <input disabled value={checkoutPageData?.poNumber} />
              </div>
            </TendorDetailsWrapper>

            <TendorDetailsWrapper>
              <div>
                <p>Req. Delivery Date</p>
                <input disabled value={moment(checkoutPageData?.requestedDate).format('MM/DD/YYYY')} />
              </div>
              <div>
                <p>Delivery Window</p>
                <div className='pickup-window-calss'>
                  <input disabled value={checkoutPageData?.appointmentStartTime} />
                  <p>To</p>
                  <input disabled value={checkoutPageData?.appointmentEndTime} />
                </div>
              </div>
            </TendorDetailsWrapper>

            <Heading>Review Order:</Heading>
            <hr style={{ margin: '0px' }} />
            <div className="checkout-note">
              <p className='buyer-comment'><span>Pallet Details: </span>{palletDetailsString()}</p>
              <p className='buyer-comment'><span>Load Comments: </span>{checkoutPageData?.buyerComment}</p>
              <Heading style={{ marginTop: '0px' }}>Notes to PT+ Admin</Heading>
              <div className="app-input-text">
                <textarea
                  name="note"
                  maxLength="200"
                  onChange={(event) => {
                    const { setFieldValue } = props
                    if (event.target.value?.length < 201) setFieldValue('note', event.target.value)
                  }}
                />
              </div>
            </div>
            <div>
              <CheckboxInput
                name="deliveryRequestSellerAcknowledgeCheck"
                label={checkBoxlabel()}
                handleSelect={() => { }}
              />
            </div>
            <Footerstyle>
              <button
                className='accept-button'
                type=''
                disabled={!props.values.deliveryRequestSellerAcknowledgeCheck}
                onClick={() => acceptFunction()}>
                Accept
              </button>
              <button
                className='reject-button'
                type=''
                onClick={() => declineDelReqOrderFunc()}>
                {pageLanguageContents?.BuyModal[40]?.Reject}
              </button>
            </Footerstyle>
          </Location>
        </PayWith>

      </div >
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=''
        content={modalContent}
        link={modalLink}
        alertType={alertType}
        callBackAlert={() => {
          if (alertType === 'sellerDelReqOrderCheckoutDecline') {
            history.push({ pathname: "/my-orders", });
          } else if (alertType === 'sellerDelReqOrderCheckoutAccept') {
            localStorage.setItem('manageOrderTabFromPtPlusScheduledPost', 1)
            history.push({ pathname: "/my-orders", });
          }
        }}
      />
      <ConfirmationModal
        isOpen={yesNoConfirmationmodal}
        toggle={() => {
          setYesNoConfirmationModal(!yesNoConfirmationmodal);
          setConfirmationComment("");
        }}
        onClickHander={(val) => {
          if (val === "no") {
          } else {
            if (alertType === 'declineOrder') declineDelReqOrderConfirmation()
          }
        }}
        content={yesNoConfirmationModalContent}
        confirmationComment={confirmationComment}
        setconfirmationComment={setConfirmationComment}
      />
    </>
  );
};

export default ViewDetails;

const Description = styled.div`
  position: relative;
  padding-left: 62px;

  img.right-arrow {
    position: absolute;
    left: -36px;
  }
  .product-header-sec{
    margin-top: 10px;
    margin-bottom: 10px;
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    @media (max-width: 767px) {
      grid-template-columns: 80% 1fr;
    }
  }
`;